module.exports = __webpack_public_path__ + "media/images/use_cases/ecommerce_testing-48d4929342fbdb4e9bac4db8aee9cda3.svg";